import { useTheme } from 'styled-components';
import { Flex } from 'front-commons/ds/components';
import { useHeader } from '../../context';
import { useBottomRowHeight } from './hooks/useBottomRowHeight';
import { OrderImportButton } from '../OrderImportButton';
import { HeaderBoni } from './components/HeaderBoni';
import { HeaderNav } from './components/HeaderNav';
import { OpenBasketButton } from './components/OpenBasketButton';
import type { HeaderBottomRowProps } from './interfaces';

export function HeaderBottomRow({
	basketData,
	catalogMenuItems,
	isSuggestionsProductNotifierExpired,
	isTopRowVisible = true,
	loadingBasket,
	showBasketButton,
	type = 'logged',
	handleOpenBasket,
}: HeaderBottomRowProps) {
	const { fidelity: fidelityControls, orderImport: orderImportControls } = useHeader();
	const { breakpoints } = useTheme();

	const showFidelity = fidelityControls.store.status !== 'DISABLED' && type === 'home';

	const bottomRowRef = useBottomRowHeight();

	return (
		<Flex
			display="block"
			gap="normal"
			position="sticky"
			top="0"
			transition="transform 0.3s ease-in-out"
			zIndex="100"
			transform={isTopRowVisible ? 'translateY(0)' : 'translateY(calc(-1 * var(--toprow-height, 100px)))'}
			raw={{ backgroundColor: 'var(--surface-white)' }}
			ref={bottomRowRef}
			data-testid="header-bottom-row"
		>
			<Flex
				maxWidth="1224px"
				width="100%"
				gap="1rem"
				justifyContent="space-between"
				alignItems="center"
				raw={{
					marginInline: 'auto',
					paddingRight: '1rem',
					'@media screen': { [`@media (min-width: ${breakpoints.medium})`]: { paddingRight: '0' } },
				}}
			>
				<HeaderNav
					catalogMenuItems={catalogMenuItems}
					isSuggestionsProductNotifierExpired={isSuggestionsProductNotifierExpired}
				/>

				<Flex gap="24px" alignItems="center">
					{showFidelity && <HeaderBoni />}

					<OrderImportButton {...orderImportControls} />

					{showBasketButton && (
						<OpenBasketButton
							basketData={basketData}
							handleOpenBasket={handleOpenBasket}
							loadingBasket={loadingBasket}
						/>
					)}
				</Flex>
			</Flex>
		</Flex>
	);
}
